<template>
  <div>
    <b-card
      no-body
      class="mb-0 mt-0"
    >
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <legend style="font-size:16px;">
              Reclassification
            </legend>
            <hr>
            <validation-observer
              ref="dataForm"
              #default="{ invalid }"
            >
              <b-form
                ref="form"
                @submit.stop.prevent="handleUpdate"
              >
                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      v-if="station.type !== 4"
                      label-for="code"
                      label="M/CODE"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="M/CODE"
                        rules=""
                      >
                        <b-form-input
                          id="code"
                          v-model="station.station.code"
                          name="code"
                          size="sm"
                          disabled
                        />
                      </validation-provider>
                    </b-form-group>

                    <b-form-group
                      v-if="station.type === 4"
                      label-for="code"
                      label="M/CODE"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="M/CODE"
                        rules=""
                      >
                        <b-form-input
                          id="code"
                          v-model="station.station.market.code"
                          name="code"
                          size="sm"
                          disabled
                        />
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="5">
                    <b-form-group
                      v-if="station.type !== 4"
                      label-for="name"
                      label="Market Name"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Market Name"
                        rules=""
                      >
                        <b-form-input
                          id="name"
                          v-model="station.station.name"
                          name="name"
                          size="sm"
                          disabled
                        />
                      </validation-provider>
                    </b-form-group>

                    <b-form-group
                      v-if="station.type === 4"
                      label-for="name"
                      label="Market Name"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Market Name"
                        rules=""
                      >
                        <b-form-input
                          id="name"
                          v-model="station.station.market.name"
                          name="name"
                          size="sm"
                          disabled
                        />
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group
                      label-for="sale_id"
                      label="Sale #"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules=""
                      >
                        <b-form-select
                          v-if="station.type !== 4"
                          id="sale_id"
                          v-model="sale_id"
                          size="sm"
                          name="sale_id"
                        >
                          <b-form-select-option :value="null">
                            Select...
                          </b-form-select-option>
                          <b-form-select-option
                            v-for="sale in station.station.sales.filter((e) => e.online)"
                            :key="sale.id"
                            :value="sale.id"
                          >
                            {{ sale.number }}
                          </b-form-select-option>
                        </b-form-select>

                        <b-form-select
                          v-else
                          id="sale_id"
                          v-model="sale_id"
                          size="sm"
                          name="sale_id"
                        >
                          <b-form-select-option :value="null">
                            Select...
                          </b-form-select-option>
                          <b-form-select-option
                            v-for="sale in station.station.market.sales.filter((e) => e.online)"
                            :key="sale.id"
                            :value="sale.id"
                          >
                            {{ sale.number }}
                          </b-form-select-option>
                        </b-form-select>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      label-for="registrationNumber"
                      label="Grower #"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Grower #"
                        rules=""
                      >
                        <b-form-input
                          id="registrationNumber"
                          v-model="tag.grower.registrationNumber"
                          name="registrationNumber"
                          size="sm"
                          disabled
                        />
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="5">
                    <b-form-group
                      label-for="growerName"
                      label="Grower Name"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Grower Name"
                        rules=""
                      >
                        <b-form-input
                          id="growerName"
                          v-model="tag.grower.name"
                          name="growerName"
                          size="sm"
                          disabled
                        />
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      label-for="tag"
                      label="Bale Tag"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Bale Tag"
                        rules=""
                      >
                        <b-form-input
                          id="tag"
                          ref="refTag"
                          v-model="tag.tagBarcode"
                          name="tag"
                          size="sm"
                          autofocus
                          @keyup.enter.prevent="getTag()"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.tagBarcode"
                          class="text-danger"
                        >{{ serverErrors.tagBarcode[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="5">
                    <b-form-group
                      label-for="barcode"
                      label="Bale Ticket"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="barcode"
                        rules=""
                      >
                        <b-form-input
                          id="barcode"
                          ref="refTicket"
                          v-model="tag.ticket.barcode"
                          name="barcode"
                          size="sm"
                          :disabled="tag.ngrade_id != null"
                          @keyup.enter.prevent="getTicket()"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.barcode"
                          class="text-danger"
                        >{{ serverErrors.barcode[0] }}</small>
                        <small
                          v-if="serverErrors && !serverErrors.barcode && serverErrors.item"
                          class="text-danger"
                        >{{ serverErrors.item[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="3">
                    <b-form-group
                      label-for="fgrade"
                      label="Factory Grade"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="fgrade"
                        rules=""
                      >
                        <b-form-input
                          id="fgrade"
                          ref="refGrade"
                          v-model="tag.fgrade"
                          name="fgrade"
                          size="sm"
                          list="fgrades"
                          @keyup.enter.prevent="validateGrade()"
                        />
                        <datalist id="fgrades">
                          <option
                            v-for="grade in grades.filter((e) => e.type === 2)"
                            :key="grade.id"
                            :value="grade.name"
                          />
                        </datalist>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.fgrade"
                          class="text-danger"
                        >{{ serverErrors.fgrade[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      label-for="mass"
                      label="Bought KGs"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Bought KGs"
                        rules=""
                      >
                        <b-form-input
                          id="mass"
                          v-model="tag.mass"
                          name="mass"
                          size="sm"
                          disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.mass"
                          class="text-danger"
                        >{{ serverErrors.mass[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="3">
                    <b-form-group
                      label-for="reweighed"
                      label="Reweighed KGs"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="reweighed"
                        rules=""
                      >
                        <b-form-input
                          id="reweighed"
                          ref="refReweighed"
                          v-model="tag.reweighed"
                          name="reweighed"
                          size="lg"
                          disabled
                          style="font-weight:bold;font-size:1.5em;"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.reweighed"
                          class="text-danger"
                        >{{ serverErrors.reweighed[0] }}</small>
                        <br v-if="serverErrors && serverErrors.variance"><small
                          v-if="serverErrors && serverErrors.variance"
                          class="text-danger"
                        >{{ serverErrors.variance[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="2">
                    <b-form-group
                      label-for="variance"
                      label="Variance"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="variance"
                        rules=""
                      >
                        <b-form-input
                          id="variance"
                          v-model="tag.variance"
                          name="variance"
                          size="sm"
                          disabled
                        />
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-row>
              <b-col
                cols="12"
                md="12"
              >
                <div class="d-flex justify-content-between">
                  <span style="font-size:16px;">Buying Data</span>
                  <b-button
                    size="sm"
                    variant="outline-success"
                    @click="connectSerialPort()"
                  >
                    <span>Connect Scale</span>
                  </b-button>
                </div>
                <hr>
              </b-col>
            </b-row>
            
            
            <b-row v-if="tag.ngrade_id">
              <b-col cols="6">
                <b-row>
                  <!-- <b-col cols="6">
                    <b-form-group
                      label-for="classifier"
                      label="Classifier"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="classifier"
                        rules=""
                      >
                        <b-form-input
                          id="classifier"
                          ref="refClassifier"
                          v-model="tag.classifier"
                          name="classifier"
                          list="classifiers"
                          size="sm"
                          @keyup.enter.prevent="validateClassfifer()"
                        />
                        <datalist id="classifiers">
                          <option
                            v-for="buyer in classifiers.filter((e) => e.type == 1)"
                            :key="buyer.id"
                            :value="buyer.code.toUpperCase()"
                          />
                        </datalist>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.classifier_id"
                          class="text-danger"
                        >{{ serverErrors.classifier_id[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col> -->

                  <b-col cols="12">
                    <b-form-group
                      label-for="buyer"
                      label="Classifier"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="buyer"
                        rules=""
                      >
                        <b-form-input
                          id="buyer"
                          ref="refBuyer"
                          v-model="tag.buyer"
                          name="buyer"
                          list="buyers"
                          size="sm"
                          @keyup.enter.prevent="validateBuyer()"
                        />
                        <datalist id="buyers">
                          <option
                            v-for="buyer in classifiers.filter((e) => e.type == 2 && !e.factory)"
                            :key="buyer.id"
                            :value="buyer.code.toUpperCase()"
                          />
                        </datalist>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.blender_id"
                          class="text-danger"
                        >{{ serverErrors.blender_id[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label-for="ngrade_id"
                      label="N/Grade"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="ngrade_id"
                        rules=""
                      >
                        <b-form-input
                          id="ngrade_id"
                          ref="refNGrade"
                          v-model="tag.ngrade"
                          name="ngrade_id"
                          list="ngrades"
                          size="sm"
                          :disabled="tag.ngrade_id != null"
                          @keyup.enter.prevent="validateNGrade()"
                        />
                        <datalist id="ngrades">
                          <option
                            v-for="grade in grades.filter((e) => e.type == 1)"
                            :key="grade.id"
                            :value="grade.name.toUpperCase()"
                          />
                        </datalist>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.ngrade_id"
                          class="text-danger"
                        >{{ serverErrors.ngrade_id[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="6">
                    <b-form-group
                      label-for="hgrade_id"
                      label="H/Grade"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="hgrade_id"
                        rules=""
                      >
                        <b-form-input
                          id="hgrade_id"
                          ref="refHGrade"
                          v-model="tag.hgrade"
                          name="hgrade_id"
                          list="hgrades"
                          size="sm"
                          :disabled="tag.hgrade_id != null"
                          @keyup.enter.prevent="validateHGrade()"
                        />
                        <datalist id="hgrades">
                          <option
                            v-for="grade in grades.filter((e) => e.type == 2)"
                            :key="grade.id"
                            :value="grade.name.toUpperCase()"
                          />
                        </datalist>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.hgrade_id"
                          class="text-danger"
                        >{{ serverErrors.hgrade_id[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="6" />
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <!-- <b-col cols="12" md="6">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..."
                                size="sm" />
                            <b-button variant="primary" size="sm" @click="invokeCreateForm()">
                                <span class="text-nowrap">Register Grade</span>
                            </b-button>
                        </div>
                    </b-col> -->
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(ticket)="data">
          <span v-if="data.item.ticket != null">{{ data.item.ticket.barcode }}</span>
        </template>

        <template #cell(grade)="data">
          <span v-if="data.item.ticket != null">{{ data.item.ticket.grade }}</span>
        </template>

        <template #cell(fgrade)="data">
          <span v-if="data.item.ticket != null">{{ data.item.ticket.fgrade }}</span>
        </template>

        <template #cell(reweighed)="data">
          <span v-if="data.item.ticket != null">{{ data.item.ticket.reweighed }}</span>
        </template>

        <template #cell(variance)="data">
          <span v-if="data.item.ticket != null">{{ data.item.ticket.reweighed - data.item.mass < 0? (data.item.ticket.reweighed - data.item.mass).toLocaleString() : '+'+(data.item.ticket.reweighed - data.item.mass).toLocaleString() }}</span>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, validate } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
    BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import store from '@/store'
import axios from '@axios'
import reclassificationStoreModule from '@/views/cromis/buying/reclassification/reclassificationStoreModule'
import useReclassificationList from '@/views/cromis/buying/reclassification/useReclassificationList'

export default {
    components: {
        vSelect,
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        vSelect,
        BDropdown,
        BDropdownItem,
        BSpinner,
        ValidationObserver,
        ValidationProvider,
    },
    directives: {},
    props: {},

    setup(props, context) {
        const serverErrors = ref(null)
        const saving = ref(false)
        const dataForm = ref(null)

        const refTag = ref(null)
        const refGrade = ref(null)
        const refReweighed = ref(null)
        const refTicket = ref(null)
        const refClassifier = ref(null)
        const refBuyer = ref(null)
        const refNGrade = ref(null)
        const refHGrade = ref(null)

        const port = ref(null)

        const user = ref(JSON.parse(localStorage.getItem('userData')))
        const { station } = user.value

        const grades = ref([])
        const classifiers = ref([])

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            // Filters
            sale_id,
        } = useReclassificationList()

        const tag = ref({
            id: null,
            tagBarcode: null,
            barcode: null,
            mass: null,
            reweighed: null,
            sale_id: sale_id.value,
            reclassification: true,
            grower: {
                id: null,
                name: null,
                registrationNumber: null,
                number: null,
            },
            ticket: {
                id: null,
                barcode: null,
                mass: null,
            },
            // classifier: null,
            // classifier_id: null,
            buyer: null,
            blender_id: null,
            fgrade: null,
            fgrade_id: null,
            buyer_id: null,
            ngrade: null,
            ngrade_id: null,
            hgrade: null,
            hgrade_id: null,
        })

        const CROMIS_STORE_MODULE_NAME = 'cromis-reclassification'

        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, reclassificationStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(() => {
            store.dispatch('cromis-reclassification/grades')
                .then(response => {
                    grades.value = response.data.grades
                })
                .catch(error => {
                    console.log('got error', error)
                })

            store.dispatch('cromis-reclassification/classifiers')
                .then(response => {
                    classifiers.value = response.data.classifiers
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const connectSerialPort = async () => {
            console.log(navigator)
            if (!('serial' in navigator)) {
                console.error('Serial port is not supported by this browser')
                return
            }

            try {
                // Request and open the port
                port.value = await navigator.serial.requestPort()
                console.log('Serial port selected')

                await port.value.open({
                    baudRate: 9600,
                    dataBits: 8,
                    stopBits: 1,
                    flowControl: 'none',
                })

                // Create a TextDecoderStream to convert bytes to text
                const decoder = new TextDecoderStream()
                port.value.readable.pipeTo(decoder.writable)
                const reader = decoder.readable.getReader()

                const buffer = '' // Buffer to accumulate incoming data

                readSerialData(reader, buffer)
            } catch (error) {
                console.error('Error opening serial port', error)
            }
        }

        const readSerialData = async (reader, buffer) => {
            try {
                const readings = []
                let mass = ''

                while (true) {
                    const { value, done } = await reader.read()

                    if (done) {
                        console.log('Stream closed')
                        break
                    }

                    if (value) {
                        // Accumulate the data in the buffer
                        // buffer += value;
                        // mass = ''+readings[0]+''+readings[1]
                        // readings.splice(0)

                        if (readings.length === 0 && value.includes('\x02')) {
                            readings.push(value)
                        } else {
                            readings.push(value)
                            if (value.includes('\x03')) {
                                console.log(readings)
                                mass = readings.join('').replace(/[\x00-\x1F]/g, '').trim()
                                console.log('Mass', mass)
                                tag.value.reweighed = mass
                                readings.splice(0)
                            }
                        }

                        console.log('Received data:', value)

                        // processLine(value)

                        // Look for complete lines (delimited by '\r\n')
                        // let lines = buffer.split('\r\n')

                        // Process all lines except the last (incomplete)
                        // for (let i = 0; i < lines.length - 1; i++) {
                        //     processLine(lines[i])
                        // }

                        // Keep the incomplete line in the buffer
                        // buffer = lines[lines.length - 1];
                    }
                }
            } catch (error) {
                console.error('Error reading serial data', error)
            }
        }

        function extractTextBetweenControlChars(input) {
            // Regular expression to match text between \u0002 and \u0003
            const match = input.match(/\u0002(.*?)\u0003/)

            // Return extracted text or null if no match is found
            return match ? match[1].trim() : null
        }

        const processLine = line => {
            console.log('Processing Hellos line:', line.replace('K', '').replace('k', '').replace('G', '').replace('g', '')
                .replaceAll(' ', ''))
            const result = extractTextBetweenControlChars(line.toLowerCase().replace('k', '').replace('g', '').replaceAll(' ', ''))

            // Example line: 'S S 176.161 g'
            // if(line.trim().length > 0 && line.includes("g")){
            //     // Extract only the numeric weight value
            //     const weightData = line.trim().replace(/[^0-9.]/g, '');
            //     if (weightData) {
            //         tag.value.reweighed = weightData;
            //         console.log('Weight:', `${weightData} g`);
            //     }
            // }

            if (result != null) {
                console.log('============NDANI=============')
                console.log(result)
                console.log('==========NJE===============')

                tag.value.reweighed = result.toLowerCase().replace('k', '').replace('g', '').replaceAll(' ', '')
            }
        }

        const getTag = async () => {
            await store.dispatch('cromis-reclassification/reclassify', { tagBarcode: tag.value.tagBarcode }).then(response => {
                tag.value = response.data.tag
                tag.value.reclassification = true
            })
                .catch(error => {
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    }
                    console.log('got error', error)
                })

            if (tag.value.id == null) {
                tag.value.tagBarcode = null
                refTag.value.focus()
            } else {
                // tag.value.reweighed = 45.34
                serverErrors.value = null

                if (tag.value.ticket.barcode == null) {
                    refTicket.value.focus()
                } else {
                    refGrade.value.focus()
                }
            }
        }

        const getTicket = async () => {
            await store.dispatch('cromis-reclassification/reclassify', { sale_id: sale_id.value, tagBarcode: tag.value.ticket.barcode }).then(response => {
                if (response.data && response.data.tag) {
                    tag.value.ticket.barcode = response.data.tag.barcode
                    tag.value.barcode = response.data.tag.barcode
                }

                if (tag.value.ticket.barcode != null) {
                    refGrade.value.focus()
                } else {
                    refTicket.value.focus()
                }
            })
                .catch(error => {
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    }
                    console.log('got error', error)

                    tag.value.ticket.barcode = null
                    refTicket.value.focus()
                })
        }

        const validateGrade = async () => {
            let valid = false

            if (tag.value.fgrade == null) {
                serverErrors.value = {
                    fgrade: ['Grade is required'],
                }
            } else {
                const grade = grades.value.find(grade => grade.name.toUpperCase() == tag.value.fgrade.toUpperCase() && grade.type == 2)

                if (grade == null) {
                    tag.value.fgrade = null,
                    tag.value.fgrade_id = null,
                    tag.value.hgrade = null,
                    tag.value.hgrade_id = null,
                    serverErrors.value = {
                        fgrade: ['Factory grade does not exist'],
                    }
                } else {
                    let rightGrade = true

                    if (tag.value.grower.grower_category != grade.grade_category) {
                        rightGrade = false
                        serverErrors.value = {
                            fgrade: [`Invalid ${tag.value.grower.type}`],
                        }
                    }

                    if (rightGrade) {
                        tag.value.fgrade = grade.name
                        tag.value.fgrade_id = grade.id
                        tag.value.hgrade = grade.name
                        tag.value.hgrade_id = grade.id
                        serverErrors.value = null
                        valid = true
                    }
                }
            }

            if (!valid) {
                tag.value.fgrade = null
                refGrade.value.focus()
            } else {
                serverErrors.value = null

                if(!tag.value.buyer){
                  refBuyer.value.focus()
                  return
                }

                if (tag.value.ticket.id != null) {
                    handleUpdate(tag.value)
                }
            }
        }

        const validateClassfifer = async () => {
            let valid = false

            if (tag.value.classifier == null) {
                serverErrors.value = {
                    classifier: ['Classifier is required'],
                }
            } else {
                const classifier = classifiers.value.find(classifier => classifier.code.toUpperCase() == tag.value.classifier.toUpperCase() && classifier.type == 2)

                if (classifier == null) {
                    tag.value.classifier = null,
                    tag.value.classifier_id = null,
                    serverErrors.value = {
                        classifier: ['Classifier was not found'],
                    }
                } else {
                    tag.value.classifier = classifier.code
                    tag.value.classifier_id = classifier.id
                    serverErrors.value = null
                    valid = true
                }
            }

            if (!valid) {
                tag.value.classifier = null
                refClassifier.value.focus()
            } else {
                serverErrors.value = null
                if (tag.value.blender != null) {
                    refNGrade.value.focus()
                } else {
                    refBuyer.value.focus()
                }
            }
        }

        const validateBuyer = async () => {
            let valid = false

            if (tag.value.buyer == null) {
                serverErrors.value = {
                    blender_id: ['Buyer is required'],
                }
            } else {
                const buyer = classifiers.value.find(classifier => classifier.code.toUpperCase() == tag.value.buyer.toUpperCase() && classifier.type == 2)

                if (buyer == null) {
                    tag.value.buyer = null,
                    tag.value.blender_id = null,
                    serverErrors.value = {
                        blender_id: ['Buyer was not found'],
                    }
                } else {
                    tag.value.buyer = buyer.code
                    tag.value.blender_id = null
                    tag.value.buyer_id = buyer.id
                    serverErrors.value = null
                    valid = true
                }
            }

            if (!valid) {
                tag.value.buyer = null
                refBuyer.value.focus()
            } else {
                serverErrors.value = null
                // tag.value.ngrade = null
                // tag.value.ngrade_id = null

                // tag.value.hgrade = null
                // tag.value.hgrade_id = null

                if(!tag.value.fgrade){
                  refGrade.value.focus()
                  return
                }

                if (tag.value.ticket.id !== null) {
                  handleUpdate(tag.value)
                }
            }
        }

        const validateNGrade = async () => {
            let valid = false

            if (tag.value.buyer == null) {
                serverErrors.value = {
                    ngrade_id: ['National grade is required'],
                }
            } else {
                const grade = grades.value.find(grade => grade.name.toUpperCase() == tag.value.ngrade.toUpperCase() && grade.type == 1)

                if (grade == null) {
                    tag.value.ngrade = null,
                    tag.value.ngrade_id = null,
                    serverErrors.value = {
                        ngrade_id: ['National grade was not found'],
                    }
                } else {
                    tag.value.ngrade = grade.name
                    // tag.value.ngrade_id = grade.id
                    serverErrors.value = null
                    valid = true
                }
            }

            if (!valid) {
                tag.value.ngrade = null
                refNGrade.value.focus()
            } else {
                serverErrors.value = null

                tag.value.hgrade = null
                tag.value.hgrade_id = null

                refHGrade.value.focus()
            }
        }

        const validateHGrade = async () => {
            let valid = false

            if (tag.value.buyer == null) {
                serverErrors.value = {
                    hgrade_id: ['Company grade is required'],
                }
            } else {
                const grade = grades.value.find(grade => grade.name.toUpperCase() == tag.value.hgrade.toUpperCase() && grade.type == 2)

                if (grade == null) {
                    tag.value.hgrade = null,
                    tag.value.hgrade_id = null,
                    tag.value.fgrade = null,
                    tag.value.fgrade_id = null,
                    serverErrors.value = {
                        hgrade_id: ['Company grade was not found'],
                    }
                } else {
                    tag.value.hgrade = grade.name
                    // tag.value.hgrade_id = grade.id
                    serverErrors.value = null
                    valid = true
                }
            }

            if (!valid) {
                tag.value.hgrade = null
                tag.value.hgrade_id = null
                tag.value.fgrade = null
                tag.value.fgrade_id = null
                refHGrade.value.focus()
            } else {
                serverErrors.value = null

                if (tag.value.ngrade != null) {
                    tag.value.ngrade_id = grades.value.filter(e => e.name.toUpperCase() == tag.value.ngrade.toUpperCase() && e.type == 1)[0].id
                }

                if (tag.value.hgrade != null) {
                    tag.value.hgrade_id = grades.value.filter(e => e.name.toUpperCase() == tag.value.hgrade.toUpperCase() && e.type == 2)[0].id
                    tag.value.fgrade_id = grades.value.filter(e => e.name.toUpperCase() == tag.value.hgrade.toUpperCase() && e.type == 2)[0].id
                }

                handleUpdate(tag.value)
            }
        }

        const handleUpdate = async item => {
           validateClassfifer()
           validateBuyer()
           validateHGrade()
           validateGrade()

            if(serverErrors.value == null){
              saving.value = true

              // tag.value.classifier_id = 1
              // tag.value.blender_id = 45

              await store.dispatch('cromis-reclassification/reclassify', tag.value)
                  .then(response => {
                      const { relay } = response.data.tag

                      saving.value = false

                      refetch()

                      if (relay) {
                          axios.post('https://localhost:3000/run-bat').then(resp => {
                              console.log(resp.data)
                          })
                      }

                      tag.value.tagBarcode = null
                      tag.value.mass = null
                      tag.value.fgrade = null
                      tag.value.ticket.id = null
                      tag.value.ticket.barcode = null
                      tag.value.ticket.mass = null

                      refTag.value.focus()
                  })
                  .catch(error => {
                      saving.value = false
                      if (error != undefined && error.response != undefined && error.response.status === 422) {
                          serverErrors.value = error.response.data.errors
                      } else {
                          console.log(error)
                          context.root.$swal({
                              icon: 'error',
                              title: 'Server Error',
                              text: 'Something went wrong. See tech support',
                              timer: 3000,
                              showConfirmButton: true,
                              customClass: {
                                  confirmButton: 'btn btn-danger',
                              },
                              buttonsStyling: false,
                          })
                      }

                      refTag.value.focus()

                      tag.value.tagBarcode = null
                      tag.value.mass = null
                      tag.value.fgrade = null

                      refTag.value.focus()

                      refetch()
                  })
              }
        }

        return {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            // Filters
            sale_id,

            serverErrors,
            saving,
            dataForm,
            station,
            tag,
            grades,
            classifiers,

            connectSerialPort,
            validateGrade,
            validateNGrade,
            validateHGrade,
            validateClassfifer,
            validateBuyer,
            getTag,
            getTicket,
            handleUpdate,

            refTag,
            refGrade,
            refReweighed,
            refTicket,
            refClassifier,
            refBuyer,
            refNGrade,
            refHGrade,
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
